import { MetricCard } from "@components";
import {
	AlertOctagon,
	AlertTriangle,
	BankNote01,
	Truck02,
} from "@untitledui/icons";
import type { ExpensesRankingHeader } from "../types";
import { formatCurrency } from "../utils";

type ExpensesSummaryCardsProps = {
	data?: ExpensesRankingHeader;
	isLoading?: boolean;
};

export function ExpensesSummaryCards({
	data,
	isLoading = false,
}: ExpensesSummaryCardsProps) {
	return (
		<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
			<MetricCard
				icon={<BankNote01 aria-hidden className="size-5" />}
				isLoading={isLoading}
				loadingLabel="Carregando total da frota"
				title="Total da frota"
				tone="info"
				value={formatCurrency(data?.fleetTotalCurrentMonth ?? 0)}
			/>
			<MetricCard
				icon={<Truck02 aria-hidden className="size-5" />}
				isLoading={isLoading}
				loadingLabel="Carregando média por veículo"
				title="Média por veículo"
				tone="success"
				value={formatCurrency(data?.averagePerVehicleCurrentMonth ?? 0)}
			/>
			<MetricCard
				icon={<AlertTriangle aria-hidden className="size-5" />}
				isLoading={isLoading}
				loadingLabel="Carregando veículos fora do padrão e em atenção"
				title="Veículos fora do padrão e em atenção"
				tone="warning"
				value={
					<span className="inline-flex flex-wrap items-center gap-x-4 gap-y-1">
						<span className="inline-flex items-center gap-1.5 text-error-600">
							{data?.outOfPatternCount ?? 0}
							<AlertOctagon aria-hidden className="size-6" />
							<span className="sr-only">fora do padrão</span>
						</span>
						<span className="inline-flex items-center gap-1.5 text-warning-600">
							{data?.attentionCount ?? 0}
							<AlertTriangle aria-hidden className="size-6" />
							<span className="sr-only">em atenção</span>
						</span>
					</span>
				}
			/>
		</div>
	);
}
